(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eo-colour-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-eo-colour-guide]';

    function normalise(value) {
      return String(value || '').trim().toLowerCase();
    }

    function extractNumber(label) {
      const match = String(label || '').match(/^(\d+)/);
      return match ? Number(match[1]) : 99999;
    }

    const BASE_COLOUR_ORDER = [
      'black',
      'white',
      'gray',
      'grey',
      'beige',
      'brown',
      'red',
      'pink',
      'orange',
      'yellow',
      'green',
      'blue',
      'purple',
      'gold',
      'silver',
      'bronze',
      'clear'
    ];

    const BASE_COLOUR_SWATCHES = {
      black: '#111111',
      white: '#ffffff',
      gray: '#8b8f92',
      grey: '#8b8f92',
      beige: '#d9c9a3',
      brown: '#70452f',
      red: '#a8232a',
      pink: '#dc91a5',
      orange: '#d97827',
      yellow: '#e1bc32',
      green: '#46704a',
      blue: '#315b91',
      purple: '#715083',
      gold: '#b89143',
      silver: '#aaaeb0',
      bronze: '#9b6a43',
      clear: 'linear-gradient(135deg, #fff 45%, #d8d8d8 46%, #d8d8d8 54%, #fff 55%)'
    };
    const BASE_COLOUR_TAXONOMY = {
  '1': 'black',
  '2': 'blue',
  '3': 'white',
  '4': 'gold',
  '5': 'silver',
  '6': 'beige',
  '7': 'brown',
  '8': 'gray',
  '9': 'green',
  '10': 'orange',
  '11': 'pink',
  '12': 'purple',
  '13': 'red',
  '14': 'yellow',
  '17': 'clear',
  '657': 'bronze'
};

    function canonicalBaseColour(value) {
  if (value && typeof value === 'object') {
    value = value.label || value.name || value.value || '';
  }

  const candidate = normalise(value);
  if (!candidate) return '';

  const taxonomyMatch = candidate.match(/taxonomyvalue\/(\d+)/);

  if (taxonomyMatch) {
    return BASE_COLOUR_TAXONOMY[taxonomyMatch[1]] || '';
  }

  if (candidate === 'grey') return 'gray';

  const exact = BASE_COLOUR_ORDER.find((base) => base === candidate);

  if (exact) {
    return exact === 'grey' ? 'gray' : exact;
  }

  const contained = BASE_COLOUR_ORDER.find((base) =>
    candidate.includes(base)
  );

  return contained === 'grey' ? 'gray' : contained || '';
}


function canonicalBaseColours(value) {
  const candidate = normalise(value);
  if (!candidate) return [];

  const taxonomyBases = Array.from(
    candidate.matchAll(/taxonomyvalue\/(\d+)/g),
    (match) => BASE_COLOUR_TAXONOMY[match[1]]
  ).filter(Boolean);

  if (taxonomyBases.length) {
    return [...new Set(taxonomyBases)];
  }

  const singleBase = canonicalBaseColour(value);
  return singleBase ? [singleBase] : [];
}


    function inferBaseColour(name, hex) {
      const label = normalise(name);

      const nameRules = [
        ['black', ['black', 'noir']],
        ['white', ['white', 'off-white', 'off white', 'ivory']],
        ['gray', ['grey', 'gray', 'platinum', 'silver', 'smoke']],
        ['beige', ['beige', 'neutral', 'birch', 'egg shell', 'eggshell', 'mist']],
        ['brown', ['brown', 'cognac', 'mahogany', 'hazelnut', 'caramel', 'camel', 'chocolate', 'taupe', 'cinnamon']],
        ['red', ['red', 'burgundy', 'bordeaux', 'campari', 'cherry', 'ruby', 'hermes']],
        ['pink', ['pink', 'fuschia', 'fuchsia', 'rose']],
        ['orange', ['orange', 'peach']],
        ['yellow', ['yellow']],
        ['green', ['green', 'olive', 'anise']],
        ['blue', ['blue', 'navy', 'azure', 'ocean', 'jean']],
        ['purple', ['purple', 'violet', 'lilac', 'plum']],
        ['gold', ['gold']],
        ['bronze', ['bronze']],
        ['clear', ['clear', 'lightening base']]
      ];

      for (const [base, terms] of nameRules) {
        if (terms.some((term) => label.includes(term))) return base;
      }

      const value = String(hex || '').replace('#', '');
      if (!/^[0-9a-f]{6}$/i.test(value)) return 'other';

      const red = parseInt(value.slice(0, 2), 16) / 255;
      const green = parseInt(value.slice(2, 4), 16) / 255;
      const blue = parseInt(value.slice(4, 6), 16) / 255;
      const maximum = Math.max(red, green, blue);
      const minimum = Math.min(red, green, blue);
      const lightness = (maximum + minimum) / 2;
      const delta = maximum - minimum;

      if (delta < 0.08) {
        if (lightness < 0.16) return 'black';
        if (lightness > 0.9) return 'white';
        return 'gray';
      }

      let hue = 0;
      if (maximum === red) hue = ((green - blue) / delta) % 6;
      if (maximum === green) hue = (blue - red) / delta + 2;
      if (maximum === blue) hue = (red - green) / delta + 4;
      hue = Math.round(hue * 60);
      if (hue < 0) hue += 360;

      if (lightness > 0.82 && hue >= 25 && hue <= 65) return 'beige';
      if (hue < 15 || hue >= 345) return 'red';
      if (hue < 45) return lightness < 0.55 ? 'brown' : 'orange';
      if (hue < 70) return 'yellow';
      if (hue < 165) return 'green';
      if (hue < 255) return 'blue';
      if (hue < 295) return 'purple';
      if (hue < 345) return 'pink';
      return 'other';
    }

    function createElement(tag, className, text) {
      const element = document.createElement(tag);

      if (className) {
        element.className = className;
      }

      if (text !== undefined && text !== null) {
        element.textContent = text;
      }

      return element;
    }

    function initialiseGuide(section) {
      if (section.dataset.eoInitialised === 'true') return;

      const dataElement = section.querySelector('[data-eo-colour-data]');
      const baseDataElement = section.querySelector('[data-eo-base-colour-data]');
      const grid = section.querySelector('[data-eo-colour-grid]');
      const search = section.querySelector('[data-eo-colour-search]');
      const baseFilters = section.querySelector('[data-eo-base-filters]');
      const emptyMessage = section.querySelector('[data-eo-empty]');
      const modal = section.querySelector('[data-eo-colour-modal]');
      const modalTitle = section.querySelector('[data-eo-modal-title]');
      const modalSwatch = section.querySelector('[data-eo-modal-swatch]');
      const modalProducts = section.querySelector('[data-eo-modal-products]');
      const closeButton = section.querySelector('[data-eo-modal-close]');

      if (!dataElement || !grid || !modal) return;

      let records = [];
      let baseRecords = [];

      try {
        records = JSON.parse(dataElement.textContent);
      } catch (error) {
        console.error('EO Colour Guide: invalid colour data.', error);
        return;
      }

      if (baseDataElement) {
        try {
          baseRecords = JSON.parse(baseDataElement.textContent);
        } catch (error) {
          console.warn('EO Colour Guide: invalid base-colour data.', error);
        }
      }

      const baseLookup = new Map(
  baseRecords
    .filter((record) => record.colourName && record.baseColour)
    .map((record) => [
      normalise(record.colourName),
      canonicalBaseColours(record.baseColour)
    ])
    .filter(([, bases]) => bases.length)
);
      const colours = new Map();

      records.forEach((record) => {
        if (!record.colourName) return;

        const key = normalise(record.colourName);

        if (!colours.has(key)) {
    colours.set(key, {
      name: record.colourName,
      hex: record.colourHex || '#d9d9d9',
      bases: baseLookup.get(key) || [
        inferBaseColour(record.colourName, record.colourHex)
      ].filter(Boolean),
      products: []
    });
  }

        const colour = colours.get(key);
        const productKey = `${record.productId}-${record.variantId || 'product'}`;

        const alreadyIncluded = colour.products.some(
          (product) => product.key === productKey
        );

        if (!alreadyIncluded) {
          colour.products.push({
            key: productKey,
            title: record.productTitle,
            vendor: record.productVendor,
            image: record.productImage,
            url: record.productUrl,
            available: record.available
          });
        }
      });

      const sortedColours = Array.from(colours.values()).sort((a, b) => {
        const numberDifference = extractNumber(a.name) - extractNumber(b.name);

        if (numberDifference !== 0) {
          return numberDifference;
        }

        return a.name.localeCompare(b.name);
      });

      let activeBaseColour = 'all';

      function baseColourLabel(value) {
        if (value === 'gray') return 'Grey';
        return value.charAt(0).toUpperCase() + value.slice(1);
      }

      function renderBaseFilters() {
        if (!baseFilters) return;

       const availableBases = Array.from(
  new Set(
    sortedColours.flatMap((colour) => colour.bases || [])
  )
).sort((a, b) => {
  const aIndex = BASE_COLOUR_ORDER.indexOf(a);
  const bIndex = BASE_COLOUR_ORDER.indexOf(b);
  const safeA = aIndex === -1 ? 999 : aIndex;
  const safeB = bIndex === -1 ? 999 : bIndex;

  return safeA - safeB || a.localeCompare(b);
});
        baseFilters.replaceChildren();

        ['all', ...availableBases].forEach((base) => {
          const button = createElement(
            'button',
            `eo-base-filter${base === activeBaseColour ? ' is-active' : ''}`
          );
          button.type = 'button';
          button.dataset.baseColour = base;
          button.setAttribute('aria-pressed', String(base === activeBaseColour));

          if (base !== 'all') {
            const swatch = createElement('span', 'eo-base-filter__swatch');
            swatch.setAttribute('aria-hidden', 'true');
            swatch.style.setProperty(
              '--eo-base-filter-colour',
              BASE_COLOUR_SWATCHES[base] || '#d7d7d2'
            );
            button.appendChild(swatch);
          }

          button.appendChild(
            createElement(
              'span',
              'eo-base-filter__label',
              base === 'all' ? 'All colours' : baseColourLabel(base)
            )
          );

          button.addEventListener('click', () => {
            activeBaseColour = base;
            renderBaseFilters();
            renderColours(search?.value || '');
          });

          baseFilters.appendChild(button);
        });
      }

      function closeModal() {
        if (typeof modal.close === 'function' && modal.open) {
          modal.close();
        }

        document.documentElement.classList.remove('eo-colour-modal-open');
      }

      function openModal(colour) {
        modalTitle.textContent = colour.name;
        modalSwatch.style.backgroundColor = colour.hex;
        modalProducts.replaceChildren();

        colour.products
          .sort((a, b) => a.title.localeCompare(b.title))
          .forEach((product) => {
            const card = createElement('article', 'eo-colour-product');

            const imageLink = createElement(
              'a',
              'eo-colour-product__image-link'
            );
            imageLink.href = product.url;

            if (product.image) {
              const image = document.createElement('img');
              image.className = 'eo-colour-product__image';
              image.src = product.image;
              image.alt = product.title;
              image.loading = 'lazy';
              image.width = 600;
              image.height = 600;
              imageLink.appendChild(image);
            }

            const details = createElement(
              'div',
              'eo-colour-product__details'
            );

            if (product.vendor) {
              details.appendChild(
                createElement(
                  'p',
                  'eo-colour-product__vendor',
                  product.vendor
                )
              );
            }

            const title = createElement(
              'h4',
              'eo-colour-product__title'
            );

            const titleLink = createElement('a', '', product.title);
            titleLink.href = product.url;
            title.appendChild(titleLink);
            details.appendChild(title);

            if (!product.available) {
              details.appendChild(
                createElement(
                  'p',
                  'eo-colour-product__status',
                  'Currently unavailable'
                )
              );
            }

            const viewButton = createElement(
              'a',
              'eo-colour-product__button',
              'View product'
            );
            viewButton.href = product.url;
            details.appendChild(viewButton);

            card.appendChild(imageLink);
            card.appendChild(details);
            modalProducts.appendChild(card);
          });

        document.documentElement.classList.add('eo-colour-modal-open');

        if (typeof modal.showModal === 'function') {
          modal.showModal();
        } else {
          modal.setAttribute('open', '');
        }
      }

      function renderColours(query = '') {
        const searchTerm = normalise(query);
        grid.replaceChildren();

      const filteredColours = sortedColours.filter((colour) => {
  const matchesSearch = normalise(colour.name).includes(searchTerm);

  const matchesBase =
    activeBaseColour === 'all' ||
    (colour.bases || []).includes(activeBaseColour);

  return matchesSearch && matchesBase;
});
        filteredColours.forEach((colour) => {
          const button = createElement(
            'button',
            'eo-colour-tile'
          );

          button.type = 'button';
          button.style.setProperty('--eo-tile-colour', colour.hex);
          button.setAttribute(
            'aria-label',
            `${colour.name}. View available products.`
          );

          const swatch = createElement(
            'span',
            'eo-colour-tile__swatch'
          );

          const information = createElement(
            'span',
            'eo-colour-tile__information'
          );

          information.appendChild(
            createElement(
              'span',
              'eo-colour-tile__name',
              colour.name
            )
          );

          information.appendChild(
            createElement(
              'span',
              'eo-colour-tile__count',
              `${colour.products.length} ${
                colour.products.length === 1 ? 'product' : 'products'
              }`
            )
          );

          button.appendChild(swatch);
          button.appendChild(information);
          button.addEventListener('click', () => openModal(colour));
          grid.appendChild(button);
        });

        emptyMessage.hidden = filteredColours.length !== 0;
      }

      search?.addEventListener('input', (event) => {
        renderColours(event.target.value);
      });

      closeButton?.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });

      modal.addEventListener('close', () => {
        document.documentElement.classList.remove(
          'eo-colour-modal-open'
        );
      });

      renderBaseFilters();
      renderColours();
      section.dataset.eoInitialised = 'true';
    }

    function initialiseAll() {
      document.querySelectorAll(SELECTOR).forEach(initialiseGuide);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseAll);
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section =
        event.target.matches?.(SELECTOR)
          ? event.target
          : event.target.querySelector?.(SELECTOR);

      if (section) {
        initialiseGuide(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
